import { supabase } from "@/integrations/supabase/client";
import { normalizeVitalRecord, type NormalizedVitalRecord } from "@/lib/clinical/vitalAssessment";

export function vitalErrorText(error: any) {
  return `${error?.code ?? ""} ${error?.message ?? ""} ${error?.details ?? ""}`;
}

export function isMissingVitalsTable(error: any) {
  return /42P01|relation .*vital_signs.* does not exist/i.test(vitalErrorText(error));
}

export async function readPatientVitals(patientId: string, limit = 240): Promise<NormalizedVitalRecord[]> {
  const [canonical, legacy] = await Promise.all([
    (supabase as any).from("vital_signs").select("*").eq("patient_id", patientId).order("measured_at", { ascending: false }).limit(limit),
    (supabase as any).from("patient_vital_signs").select("*").eq("patient_id", patientId).order("measured_at", { ascending: false }).limit(limit),
  ]);
  if (canonical.error && legacy.error) throw canonical.error;
  const rows = [
    ...((canonical.data ?? []) as any[]).filter((row) => !row.deleted_at).map((row) => normalizeVitalRecord({ ...row, __source_table: "vital_signs" })),
    ...((legacy.data ?? []) as any[]).filter((row) => !row.deleted_at).map((row) => normalizeVitalRecord({ ...row, __source_table: "patient_vital_signs" })),
  ];
  const seen = new Set<string>();
  return rows
    .filter((row) => {
      const key = row.id ? `${row.__source_table}:${row.id}` : `${row.measured_at}:${row.heart_rate_bpm ?? ""}:${row.systolic_mm_hg ?? ""}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => new Date(b.measured_at).getTime() - new Date(a.measured_at).getTime());
}
